import { StarRating } from "@/components/star-rating";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface RatingsSummaryProps {
  averageRating: number;
  totalRatings: number;
  className?: string;
}

export function RatingsSummary({ 
  averageRating, 
  totalRatings, 
  className 
}: RatingsSummaryProps) {
  if (totalRatings === 0) {
    return (
      <Card className={className}>
        <CardContent className="py-6">
          <div className="text-center text-muted-foreground">
            <p className="text-sm">No ratings yet</p>
            <p className="text-xs mt-1">Be the first to leave a review!</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={className}>
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center gap-2">
          <span>⭐</span>
          Rating
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="flex items-center gap-3">
          <div className="text-3xl font-bold">
            {averageRating.toFixed(1)}
          </div>
          <div>
            <StarRating rating={averageRating} size="md" />
            <p className="text-sm text-muted-foreground mt-1">
              {totalRatings} review{totalRatings !== 1 ? 's' : ''}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}